import jsPDF from "jspdf";
import { Styles } from "jspdf-autotable";

/**
 * The printed report is one grid: the driver's header block and the table of
 * their deliveries have the same number of columns (a wide leading one plus
 * eight), and both are laid out on the widths computed here. Left to its own
 * devices, autoTable sizes every table from its own content, and the two
 * drift apart by a few pixels per column — which is exactly what made the
 * report look broken.
 */
export const REPORT_MARGIN = 30;

/** Share of the content width taken by the leading column. */
const LEADING_COLUMN_SHARE = 0.26;

const REST_COLUMN_COUNT = 8;

export const REPORT_FONT_SIZE = 8;

export const REPORT_PRIMARY_COLOR = "#fb3973";

export const REPORT_BORDER_COLOR = "#E2E4E7";

export const REPORT_TEXT_COLOR = "#1B1B28";

export interface ReportGrid {
  margin: { left: number; right: number };
  tableWidth: number;
  columnStyles: Record<number, Partial<Styles>>;
}

export const getReportGrid = (pdf: jsPDF): ReportGrid => {
  const contentWidth =
    pdf.internal.pageSize.getWidth() - REPORT_MARGIN * 2;

  const leadingWidth = contentWidth * LEADING_COLUMN_SHARE;
  const restWidth = (contentWidth - leadingWidth) / REST_COLUMN_COUNT;

  const columnStyles: Record<number, Partial<Styles>> = {
    0: { cellWidth: leadingWidth, halign: "left" }
  };

  for (let index = 1; index <= REST_COLUMN_COUNT; index++) {
    columnStyles[index] = { cellWidth: restWidth };
  }

  return {
    margin: { left: REPORT_MARGIN, right: REPORT_MARGIN },
    tableWidth: contentWidth,
    columnStyles
  };
};

/** Cell styling shared by both tables of the report. */
export const getReportBaseStyles = (font: string): Partial<Styles> => ({
  font,
  fontSize: REPORT_FONT_SIZE,
  cellPadding: 5,
  lineWidth: 0.5,
  lineColor: REPORT_BORDER_COLOR,
  textColor: REPORT_TEXT_COLOR,
  valign: "middle",
  halign: "center",
  overflow: "linebreak"
});
